"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

var axios_1 = require("axios");

var axiosInstance = axios_1.default.create({
  headers: {
    post: {
      'Content-Type': 'application/json'
    }
  }
});

var Endpoint =
/** @class */
function () {
  function Endpoint() {}
  /**
   * GET request for API V5
   *
   * @return {Promise}
   */


  Endpoint.prototype.getData = function (name, params, options) {
    return axiosInstance.request(__assign({
      method: 'GET',
      url: "/good/api/v5/data/" + this.name + "/" + name,
      baseURL: "" + this.config.apiHost,
      params: __assign({}, this.config, params)
    }, options)).then(utils_1.extractResponseData);
  };
  /**
   * POST request for API V5
   *
   * @return {Promise}
   */


  Endpoint.prototype.setData = function (name, data, params) {
    return axiosInstance.request({
      method: 'POST',
      url: "/good/api/v5/data/" + this.name + "/" + name,
      baseURL: "" + this.config.apiHost,
      params: __assign({}, this.config, params),
      data: data
    }).then(utils_1.extractResponseData);
  };

  return Endpoint;
}();

exports.default = Endpoint;